import { createStore, applyMiddleware, combineReducers } from 'redux'
import { thunk } from 'redux-thunk'; // Named import, which is correct
import { composeWithDevTools } from '@redux-devtools/extension'
import authReducer from './reducers/authReducer'

const rootReducer = combineReducers({
  auth: authReducer,
  // Add other reducers here as needed
})

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
)